import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { OrganizationService } from "src/app/Service/organization/organization.service";
import { IOrganizationViewModel } from "src/app/ViewModel/OrganizationModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { CommonService } from 'src/app/Service/Common.service';

@Component({
    selector: 'app-master-organization-dialog',
    templateUrl: './edit-organization-dialog.component.html',
    styleUrls: ['./edit-organization-dialog.component.css']
})
export class EditOrganizationComponent implements OnInit {
    public actionButtonText: string = "Save";
    memberId: number | null | undefined;
    public groupForm: FormGroup = new FormGroup({
        groupName: new FormControl('', [Validators.required, Validators.maxLength(600)]),
        groupShortName: new FormControl('', [Validators.required, Validators.maxLength(50)]),
        groupCode: new FormControl('', [Validators.maxLength(20)]),
        groupLogoUrl: new FormControl(),
        groupStatus: new FormControl(true)
    });

    constructor(private _orgService: OrganizationService, private _commonService: CommonService, public _dialogRef: MatDialogRef<EditOrganizationComponent>,
        @Inject(MAT_DIALOG_DATA) public _data: IOrganizationViewModel) {

    }
    /**
     * ngOnInit - Angular Lifecycle hook
     */
    ngOnInit() {
        this.memberId = this._commonService.getLoggedInUserId();
        if (this._data != null) {
            this.actionButtonText = "Update";
            this.setFormValues();
        }
    }
    /**
     * Set form values
     */
    setFormValues() {
        this.groupForm.get('groupName')?.setValue(this._data.group_Name);
        this.groupForm.get('groupShortName')?.setValue(this._data.group_Short_Name);
        this.groupForm.get('groupCode')?.setValue(this._data.group_Code);
        this.groupForm.get('groupLogoUrl')?.setValue(this._data.group_Logo_URL);
        this.groupForm.get('groupStatus')?.setValue(this._data.is_Active);
    }

    /**
     * Save organization group
     */
    saveGroup() {
        let organization: IOrganizationViewModel = {
            group_Code: this.getFormValue('groupCode'),
            group_Name: this.getFormValue('groupName'), group_Short_Name: this.getFormValue('groupShortName'), group_Logo_URL: this.getFormValue('groupLogoUrl'),
            is_Active: this.getFormValue('groupStatus'), group_Head_Id: null, group_Id: this._data != null ? this._data.group_Id : null, user_Id: this.memberId
        };
        this._orgService.insertUpdateOrganization(organization).subscribe((res: StandardOutputModel) => {
            if (res.successCode == 200) {
                if (this._data == null)
                    organization.group_Id = +res.result;
                this._dialogRef.close({ response: res, organization: organization });
            }
            else {
                this._dialogRef.close({ response: res });
            }
        }, err => {

        });
    }

    /**
     * Get GroupForm Controls value
     * @param controlName ControlName
     */
    getFormValue(controlName: string): any {
        return this.groupForm.get(controlName)?.value;
    }

    /**
     * Close modal dialog
     */
    closeDialog() {
        this._dialogRef.close();
    }
}